"use client";

import React, { useState } from 'react';
import { Plus, Minus } from 'lucide-react';
import { FAQItemProps } from '../types';
import { useTranslations } from 'next-intl';

const keyPrefix = "playbook.macaronApp";

const messageKey = {
  faq1Question: `${keyPrefix}.faq1Question`,
  faq1Answer: `${keyPrefix}.faq1Answer`,
  faq2Question: `${keyPrefix}.faq2Question`,
  faq2Answer: `${keyPrefix}.faq2Answer`,
  faq3Question: `${keyPrefix}.faq3Question`,
  faq3Answer: `${keyPrefix}.faq3Answer`,
  faq4Question: `${keyPrefix}.faq4Question`,
  faq4Answer: `${keyPrefix}.faq4Answer`,
  faq5Question: `${keyPrefix}.faq5Question`,
  faq5Answer: `${keyPrefix}.faq5Answer`,
  faq6Question: `${keyPrefix}.faq6Question`,
  faq6Answer: `${keyPrefix}.faq6Answer`,
  faq7Question: `${keyPrefix}.faq7Question`,
  faq7Answer: `${keyPrefix}.faq7Answer`,
};

const FAQItem: React.FC<FAQItemProps> = ({ question, answer }) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="border-b border-macaron-playbook-app-border last:border-0">
      <button
        className="w-full py-5 flex items-start justify-between gap-4 text-left group"
        onClick={() => setIsOpen(!isOpen)}
      >
        {/* Item Heading: text-lg */}
        <span className={`font-medium text-lg ${isOpen ? 'text-macaron-playbook-app-primary' : 'text-macaron-playbook-app-secondary'} group-hover:text-macaron-playbook-app-primary transition-colors`}>
          {question}
        </span>
        <span className="text-macaron-playbook-app-muted group-hover:text-macaron-playbook-app-primary mt-1 shrink-0">
          {isOpen ? <Minus size={18} /> : <Plus size={18} />}
        </span>
      </button>
      <div
        className={`overflow-hidden transition-all duration-300 ease-in-out ${isOpen ? 'max-h-96 opacity-100 pb-6' : 'max-h-0 opacity-0'}`}
      >
        {/* Body: text-base */}
        <p className="text-macaron-playbook-app-secondary leading-relaxed text-base pr-8">
          {answer}
        </p>
      </div>
    </div>
  );
};

const FAQ: React.FC = () => {
  const t = useTranslations();
  const faqs = [
    {
      question: t(messageKey.faq1Question),
      answer: t(messageKey.faq1Answer),
    },
    {
      question: t(messageKey.faq2Question),
      answer: t(messageKey.faq2Answer),
    },
    {
      question: t(messageKey.faq3Question),
      answer: t(messageKey.faq3Answer),
    },
    {
      question: t(messageKey.faq4Question),
      answer: t(messageKey.faq4Answer),
    },
    {
      question: t(messageKey.faq5Question),
      answer: t(messageKey.faq5Answer),
    },
    {
      question: t(messageKey.faq6Question),
      answer: t(messageKey.faq6Answer),
    },
    {
      question: t(messageKey.faq7Question),
      answer: t(messageKey.faq7Answer),
    }
  ];

  return (
    <section className="py-16 px-6 max-w-4xl mx-auto">
      {/* Section Heading: text-3xl md:text-4xl */}
      <h2 className="text-3xl md:text-4xl font-serif text-macaron-playbook-app-primary mb-8">FAQ</h2>
      <div className="">
        {faqs.map((faq, index) => (
          <FAQItem key={index} {...faq} />
        ))}
      </div>
    </section>
  );
};

export default FAQ;